export default __webpack_public_path__ + "/dist/images/4075291.8fdc1e5f3ad55049d2163a2396e3d7c2.png";